import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _fitnessDisciplineSlu;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var BrowseCategorySlug;
/**
 * with categories that don't have their own page (i.e. Beyond the Ride), we can
 * default to ALL
 */

(function (BrowseCategorySlug) {
  BrowseCategorySlug["Cardio"] = "cardio";
  BrowseCategorySlug["Cycling"] = "cycling";
  BrowseCategorySlug["Outdoor"] = "outdoor";
  BrowseCategorySlug["Strength"] = "strength";
  BrowseCategorySlug["Stretching"] = "stretching";
  BrowseCategorySlug["TotalBody"] = "total_body";
  BrowseCategorySlug["Running"] = "running";
  BrowseCategorySlug["Yoga"] = "yoga";
  BrowseCategorySlug["Walking"] = "walking";
  BrowseCategorySlug["Bootcamp"] = "bootcamp";
  BrowseCategorySlug["Meditation"] = "meditation";
  BrowseCategorySlug["BikeBootcamp"] = "bike_bootcamp";
  BrowseCategorySlug["Caesar"] = "caesar";
  BrowseCategorySlug["CaesarBootcamp"] = "caesar_bootcamp";
  BrowseCategorySlug["Rowing"] = "rowing";
  BrowseCategorySlug["RowBootcamp"] = "row_bootcamp";
  BrowseCategorySlug["Free"] = "free";
  BrowseCategorySlug["All"] = "all";
})(BrowseCategorySlug || (BrowseCategorySlug = {}));

export var fitnessDisciplineSlugToBrowseCategorySlug = (_fitnessDisciplineSlu = {
  BEYOND_THE_RIDE: BrowseCategorySlug.All
}, _defineProperty(_fitnessDisciplineSlu, 'BIKE_BOOTCAMP', BrowseCategorySlug.BikeBootcamp), _defineProperty(_fitnessDisciplineSlu, "CAESAR", BrowseCategorySlug.All), _defineProperty(_fitnessDisciplineSlu, "CAESAR_BOOTCAMP", BrowseCategorySlug.All), _defineProperty(_fitnessDisciplineSlu, "CARDIO", BrowseCategorySlug.Cardio), _defineProperty(_fitnessDisciplineSlu, "CIRCUIT", BrowseCategorySlug.Bootcamp), _defineProperty(_fitnessDisciplineSlu, "CYCLING", BrowseCategorySlug.Cycling), _defineProperty(_fitnessDisciplineSlu, "MEDITATION", BrowseCategorySlug.Meditation), _defineProperty(_fitnessDisciplineSlu, "RUNNING", BrowseCategorySlug.Running), _defineProperty(_fitnessDisciplineSlu, "STRENGTH", BrowseCategorySlug.Strength), _defineProperty(_fitnessDisciplineSlu, "STRETCHING", BrowseCategorySlug.Stretching), _defineProperty(_fitnessDisciplineSlu, "WALKING", BrowseCategorySlug.Walking), _defineProperty(_fitnessDisciplineSlu, "YOGA", BrowseCategorySlug.Yoga), _fitnessDisciplineSlu);
export var browseCategorySlugToCaesarMapper = function browseCategorySlugToCaesarMapper(browseCategorySlug) {
  if (browseCategorySlug === BrowseCategorySlug.Rowing) {
    return BrowseCategorySlug.Caesar;
  }

  if (browseCategorySlug === BrowseCategorySlug.RowBootcamp) {
    return BrowseCategorySlug.CaesarBootcamp;
  }

  return browseCategorySlug;
};
export var browseCategorySlugFromCaesarMapper = function browseCategorySlugFromCaesarMapper(browseCategorySlug) {
  if (browseCategorySlug === BrowseCategorySlug.Caesar) {
    return BrowseCategorySlug.Rowing;
  }

  if (browseCategorySlug === BrowseCategorySlug.CaesarBootcamp) {
    return BrowseCategorySlug.RowBootcamp;
  }

  return browseCategorySlug;
};
export var browseCategoryFromCaesarMapper = function browseCategoryFromCaesarMapper(browseCategory) {
  return _objectSpread(_objectSpread({}, browseCategory), {}, {
    slug: browseCategorySlugFromCaesarMapper(browseCategory.slug)
  });
};